import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { materialSymbols } from '../../../../../../shared/constants/material-symbols';
import { IApiResponse } from '../../../../../../shared/models/api-response';
import { ToastService } from '../../../../../../shared/services/toast.service';
import { FinaliseSrsBallotRequest } from '../../../../shared/models/sr/finalise-srs-ballot-request';
import { SrsBallotReviewOutcome } from '../../../../shared/models/sr/srs-ballot-review-outcome';
import { SrsBallotReviewStage } from '../../../../shared/models/sr/srs-ballot-review-stage';
import { SrsBallotService } from '../../../../shared/services/srs-ballot.service';

@Component({
    selector: 'app-srs-finalise-ballot-modal',
    templateUrl: './srs-finalise-ballot-modal.component.html',
    styleUrl: './srs-finalise-ballot-modal.component.scss',
    standalone: false
})
export class SrsFinaliseBallotModalComponent {
  @Input() majorityVote: {
    label: string;
    value: number;
    color: string;
    icon: string;
    ballotId: string;
  } | null = null;
  @Input() isAllNoResponse: boolean = false;
  //@Output() refreshEligibleVoter: EventEmitter<void> = new EventEmitter<void>();

  icon: string = '';
  color: string = '';
  label: string = '';
  ballotId: string = '';
  finalComment: string = '';
  isCheckboxChecked: boolean = false;
  withdraw: { color: string; icon: string; text: string } = {
    color: '#B0B0B0',
    icon: materialSymbols.logout,
    text: 'Withdraw'
  };

  finaliseSrsBallotRequest: FinaliseSrsBallotRequest = {
    ballotId: '',
    resolutionId: '',
    reviewStageId: SrsBallotReviewStage.ReadyForReviewSubmission,
    reviewOutcomeId: SrsBallotReviewOutcome.Submit,
    comment: '',
    //srtRevisitDate: null,
  };


  subscriptions: Subscription = new Subscription();

  constructor(
    public activeModal: NgbActiveModal,
    private _toastService: ToastService,
    private _srsBallotService: SrsBallotService
  ) {}

  ngOnInit() {
    this.initialize(this.majorityVote);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  initialize(
    majorityVote: {
      label: string;
      value: number;
      color: string;
      icon: string;
      ballotId: string;
    } | null
  ) {
    if(this.isAllNoResponse){
      this.label = this.withdraw.text;
      this.icon = this.withdraw.icon;
      this.color = this.getColorClass(this.withdraw.color);
      this.finaliseSrsBallotRequest.ballotId = majorityVote?.ballotId || '';
      this.finaliseSrsBallotRequest.resolutionId = this.getVoteTypeId(this.label);
    } else if (majorityVote && majorityVote.label) {
      const { label, icon, color, ballotId } = majorityVote;
      this.label = label;
      this.icon = icon;
      this.color = this.getColorClass(color);
      this.finaliseSrsBallotRequest.ballotId = ballotId;
      this.finaliseSrsBallotRequest.resolutionId = this.getVoteTypeId(label);
    }
  }

  getColorClass(color: string): string {
    switch (color) {
      case '#1A936F':
        return 'text-green-500';
      case '#007AC9':
        return 'text-blue-500';
      case '#B0B0B0':
        return 'text-grey-600';
      case '#FFB500':
        return 'text-orange-700';
      default:
        return 'text-black';
    }
  }

  getVoteTypeId(label: string): string {
    switch (label) {
      case 'Reconfirm':
        return 'SVT_RECONFIRM';
      case 'Revise':
        return 'SVT_REVISE';
      case 'Withdraw':
        return 'SVT_WITHDRAW';
      default:
        return 'SVT_NONE';
    }
  }

  confirm() {
    if (this.finalComment && this.isCheckboxChecked) {
      this.finaliseSrsBallotRequest.comment = this.finalComment;
      this.subscriptions.add(this._srsBallotService.finaliseSrsBallot(this.finaliseSrsBallotRequest).subscribe({
        next: (response: IApiResponse<string>) => {
          if(response && response.success) {
            this._toastService.showSuccess("Ballot successfully finalised.", 'Systematic Review Ballot');
            this.activeModal.close(this.finaliseSrsBallotRequest.ballotId);
          }
        },
        error: (error) => {
          this._toastService.showError("Unexpected error occurred. Please try again or contact IT Support if issue persists.");
          this.activeModal.close(this.finaliseSrsBallotRequest.ballotId);
        }
      }));
    }
  }

  cancel() {
    this.activeModal.dismiss('cancel');
  }
}
